"use client";

import { useWebSocketInternal, type WebSocketRequestMessageType } from "utils";
import { useAppConfiguration } from "appConfig";

export function useWebSocket(
  contentType: string,
  id: string,
  onMessageCallback: VoidFunction,
  onErrorCallback?: (event: any) => VoidFunction,
  webSocketIdentifier?: string
) {
  const getRequest = (): WebSocketRequestMessageType => ({
    Subscribe: {
      ContentType: contentType,
      Id: id,
    },
  });

  const appConfiguration = useAppConfiguration();

  return useWebSocketInternal(
    appConfiguration.apiWebSocketUrl
      ? `${appConfiguration.apiWebSocketUrl}/api/ws`
      : "",
    getRequest,
    onMessageCallback,
    onErrorCallback,
    webSocketIdentifier
  );
}
